import React, { createContext, useState, useContext } from 'react';
import { getBasketList } from '../utils/api'

// ایجاد Context
const CartContext = createContext();

// هوک برای دسترسی به Context
export const useCart = () => useContext(CartContext);

// Provider برای مدیریت وضعیت سبد خرید
export const CartProvider = ({ children }) => {


    const [cartItems, setCartItems] = useState('');
    const [basketLists, setBasketLists] = useState('');
    console.log('..ewrwerwe.....')

    const addToCart = async () => {
        console.log('.......')
        let clientId = JSON.parse(localStorage.getItem('userInfo')).si
        try {
            let res = await getBasketList(clientId)
            if (res.status == 200) {
                setCartItems(res.data.length); // اطمینان از مقداردهی صحیح
                setBasketLists(res.data)
            }
        } catch (error) {

        }
        // const items = sessionStorage.getItem('cartItems');
        // if (items) {
        //     const parsedItems = JSON.parse(items);
        //     setCartItems(parsedItems.length); // اطمینان از مقداردهی صحیح
        // } else {
        //     setCartItems(0); // مقدار پیش‌فرض
        // }
    };


    return (
        <CartContext.Provider value={{ cartItems, addToCart,basketLists }}>
            {children}
        </CartContext.Provider>
    );
};
